import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '社会热点', path: '/category/society' },
  { label: '娱乐资讯', path: '/category/entertainment' },
  { label: '生活动态', path: '/category/life' },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : '/search');
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <>
      <div className="hidden bg-primary-950 text-background-50/80 md:block">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between px-4 text-xs md:px-6">
          <span className="inline-flex items-center gap-2">
            <i className="ri-flashlight-fill text-accent-400" />
            权威爆料 · 及时报道 · 深度解析 — 2026年10月12日
          </span>
          <div className="flex items-center gap-5">
            <Link to="/about" className="hover:text-background-50 transition-colors">
              关于我们
            </Link>
            <Link to="/contact" className="hover:text-background-50 transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>

      <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1400px] items-center gap-4 px-4 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-megaphone-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-black tracking-tight text-primary-700">爆料网</span>
          </Link>

          <nav className="hidden items-center lg:flex">
            {navItems.map((item) => (
              <NavLink key={item.path} to={item.path} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="ml-auto hidden items-center md:flex">
            <div className="relative">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索新闻爆料..."
                aria-label="搜索新闻爆料"
                className="h-9 w-52 rounded-md border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:bg-background-50 lg:w-64"
              />
            </div>
            <button
              type="submit"
              className="ml-2 h-9 whitespace-nowrap rounded-md bg-primary-600 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>

        {mobileOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
            <form onSubmit={submitSearch} className="relative py-2">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索新闻爆料..."
                aria-label="搜索新闻爆料"
                className="h-10 w-full rounded-md border border-background-300 bg-background-100 pl-9 pr-3 text-sm text-foreground-800 outline-none focus:border-primary-400"
              />
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `border-b border-background-200 py-3 text-sm font-medium ${
                      isActive ? 'text-primary-600' : 'text-foreground-700'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <div className="flex gap-4 pt-3 text-sm text-foreground-600">
                <Link to="/about">关于我们</Link>
                <Link to="/contact">联系我们</Link>
              </div>
            </nav>
          </div>
        ) : null}
      </header>
    </>
  );
}